export const choice_yes_no = [{ value: "YES" }, { value: "NO" }];
